import React, { useState } from 'react'
import { Props_SnippetVideo } from './Video.props'
import SharedHeading from '../Shared/Heading/Heading'
 import SnippetLink from '../Shared/Link/Link';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';


const processUrl = (url: string): string => {
    let newUrl = url

    // Handle YouTube URLs
    if (url.includes('watch?v=')) {
        newUrl = url.replace('watch?v=', 'embed/')
    } else if (url.includes('youtu.be')) {
        newUrl = url.replace('youtu.be/', 'youtube.com/embed/')
    } else if (url.includes('youtube.com/shorts/')) {
        newUrl = url.replace('youtube.com/shorts/', 'youtube.com/embed/')
    }
    
    // Handle Vimeo URLs
    if (url.includes('vimeo.com')) {
        const match = url.match(/vimeo\.com\/(\d+)/)
        if (match) {
            newUrl = `https://player.vimeo.com/video/${match[1]}`
        }
    }
    
    // Add autoplay for all URLs if not already present
    if (!newUrl.includes('autoplay=1')) {
        newUrl = `${newUrl}${newUrl.includes('?') ? '&' : '?'}autoplay=1`
    }
    
    return newUrl
}

const SnippetVideo = (props: Props_SnippetVideo) => {
    const { snippet, heading, video, paragraph, repeatable_links, links } = props

    const classSnippetTheme: string = snippet?.theme?.value ? `snippet-video--theme-${snippet.theme.value}` : ''
    const classVideoOrientation: string = video.orientation?.value ? `snippet-video--orientation-${video.orientation.value}` : ''
    const [playing, setPlaying] = useState<boolean>(false)
    const linkAlignmentClass = links?.alignment?.value
    ? `snippet-video__link-container--${links.alignment.value}`
    : '';

    // Only process the video URL when playing
    const processedUrl: string | undefined = playing && video.url?.value
        ? processUrl(video.url.value)
        : undefined

    return (
        <section className={`snippet-video ${classSnippetTheme} ${classVideoOrientation} ${playing ? 'snippet-video--playing' : ''}`}>
            { snippet.overlays?.value && (
                <>
                    <img src="/Blob/images/snippets/video/overlay-top-left.svg" loading="lazy" width="108" height="216" className="snippet-video__overlay snippet-video__overlay--top-left" alt=""></img>
                    <img src="/Blob/images/snippets/video/overlay-middle-left.svg" loading="lazy" width="56" height="56" className="snippet-video__overlay snippet-video__overlay--middle-left" alt=""></img>
                    <img src="/Blob/images/snippets/video/overlay-bottom-right.svg" loading="lazy" width="114" height="114" className="snippet-video__overlay snippet-video__overlay--bottom-right" alt=""></img>
                </>
            )}
            <div className="snippet-video__container">
                <div className="snippet-video__heading-section">
                    <SharedHeading
                    level={heading.level?.value as ('h1'|'h2'|'h3'|'h4'|'h5'|'h6') || 'h2'}
                    alignment={heading.alignment?.value as ('start'|'center'|'end')}
                    visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                    className="snippet-video__heading"
                >
                    {heading.text?.value}
                </SharedHeading> 

               {paragraph?.text?.value &&  <div className="snippet-video__content">
                   {CompileMarkdown(paragraph.text.value)}
                </div>}

                <div className={`snippet-video__link-container ${linkAlignmentClass}`}>
                    {repeatable_links?.map((link, index) => (
                        <div key={index + (link.linkHref?.value || '')} className="snippet-video__link">
                           <SnippetLink
                  key={index}
                  className="snippet-media-content__link attrax-button"
                  url={link.linkHref?.value ?? ''}
                  openInNewTab={typeof link.linkTarget?.value === 'boolean' ? link.linkTarget.value : link.linkTarget?.value === 'true'}
                  linkStyles={link.linkStyle?.value}
                >
                  {link.linkText?.value}
                </SnippetLink>
                        </div>
                    ))}
                </div>

                </div>
               
                <div className="snippet-video__container-video">
                    { video.thumbnail?.value && !playing && (
                        <figure className="snippet-video__container-thumbnail">
                            <img
                                src={video.thumbnail?.value}
                                alt=""
                                className="snippet-video__thumbnail"
                                loading="lazy"
                                width="1920"
                                height="1080"
                            />
                        </figure>
                    )}
                    { video.url?.value && (
                        <button
                            className="snippet-video__play-button attrax-button-play-white"
                            aria-label="{{js.snippet.video.button.play.aria-label}}"
                            onClick={() => setPlaying(true)}
                            type="button"
                        ></button>
                    )}
                    { processedUrl && (
                        <iframe
                            width="560"
                            height="315"
                            src={processedUrl}
                            title="YouTube video player"
                            loading="lazy"
                            allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            className="snippet-video__video"
                            allowFullScreen={true}
                        ></iframe>
                    )}
                </div>
            </div>
        </section>
    )
}

export default SnippetVideo
